import React from 'react';
import { db } from '../FirebaseComp/firebase'; 
import { collection, addDoc } from "firebase/firestore";
import './bookaneyetest.css';

function BookanEyeTest() {
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    service: 'comprehensive'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "bookeyetest"), formData);
      alert(`Appointment booked! We'll confirm your ${formData.service} eye test on ${formData.date} at ${formData.time} shortly.`);
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        service: 'comprehensive'
      });
    } catch (error) {
      console.error("Error booking appointment: ", error);
      alert("Failed to book appointment. Please try again.");
    }
  };
  return (
    <div className="booking-container">
      <div className="booking-hero">
        <div className="hero-overlay">
          <h1>Book Your Eye Test</h1>
          <p>Expert care for your vision health</p>
        </div>
      </div>

      <div className="booking-content">
        <div className="booking-form-container">
          <h2>Schedule Your Appointment</h2>
          <p className="form-subtitle">Fill out the form below and we'll contact you to confirm</p>
          
          <form onSubmit={handleSubmit} className="booking-form">
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input 
                type="tel" 
                id="phone" 
                name="phone" 
                value={formData.phone}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="date">Preferred Date</label>
                <input 
                  type="date" 
                  id="date" 
                  name="date" 
                  value={formData.date}
                  onChange={handleChange}
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="time">Preferred Time</label>
                <input 
                  type="time" 
                  id="time" 
                  name="time" 
                  value={formData.time}
                  onChange={handleChange}
                  required 
                />
              </div>
            </div>
            
            {/* <div className="form-group">
              <label htmlFor="service">Service Type</label>
              <select 
                id="service" 
                name="service" 
                value={formData.service}
                onChange={handleChange}
              >
                <option value="comprehensive">Comprehensive Eye Exam</option>
                <option value="contact-lens">Contact Lens Fitting</option>
                <option value="pediatric">Pediatric Eye Exam</option>
                <option value="dry-eye">Dry Eye Evaluation</option>
                <option value="emergency">Emergency Eye Care</option>
              </select>
            </div> */}





            <div className='services'>
              <b><p>Weekly Clinic - Public Library</p></b>
              <b><p>Monthly - Samata Sarana</p></b>
            </div>


            
            <button type="submit" className="submit-btn">Book Appointment</button>
          </form>

        </div>
        
        <div className="booking-info">
          <div className="info-card">
            <div className="icon-circle">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"/>
              </svg>
            </div>
            <h3>Affordable Pricing</h3>
            <p>We offer competitive pricing and accept most insurance plans.</p>
          </div>
          
          <div className="info-card">
            <div className="icon-circle">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
              </svg>
            </div>
            <h3>Detailed Reports</h3>
            <p>Receive comprehensive reports about your eye health and vision.</p>
          </div>
          
          <div className="info-card">
            <div className="icon-circle">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
              </svg>
            </div>
            <h3>Expert Care</h3>
            <p>Our optometrists have decades of combined experience.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookanEyeTest;